export default __webpack_public_path__ + "static/media/img2.22848308.jpeg";